import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Form, Formik, FieldArray } from "formik";
import { openSnackbar } from "../../../Redux/Actions/snackbarActions";
import { useDispatch, useSelector } from "react-redux";

import * as yup from "yup";
import { Delete, Edit } from "@mui/icons-material";
import FormControl from "Components/MUI_components/FormControl/fomikFormControl";
import Stepper from "Components/MUI_components/stepper";
import ItemMasterService from "Service/Item-master/itemMaster.service";
import AsyncAutoComplete from "../../MUI_components/AutoComplete/asynchronousAutoComplete";
import customerService from "Service/Customer/customer.service";
import { currency } from "Components/MUI_components/currencyFormatterTag";
import Loading from "Components/MUI_components/loading";
import { NumFormat } from "Components/MUI_components/currencyFormat";
import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";
import SalseOderService from "Service/Stock/salesOrder.service"

const SalesOrder = ({ setOpen, code, setSubmitted }) => {
  const dispatch = useDispatch();
  const [isLoaded, setIsLoaded] = useState(false);
  const stockLocations = useSelector((state) => state.location);
  const defaultLocationSelected = useSelector((state) => state.defaultLocation);
  const addingProduct = React.createRef();
  const [disabledForSingle, setDisabledForSingle] = useState(false);


  const initCurrentStockValue = {
    quantity: 0,
    costPrice: "",
    wholesalePrice: "",
    retailPrice: "",
    discountPercentage: "",
    discountAmount: "",
    stock: "",
    
  };

  const initValues = {
    customer: null,
    remarks: "",
    stockHistoryTemps: [],
    discountAmount: 0, // Entire quotation discount Amount 
    discountPercentage: 0,// Entire quotation discount Percentage 
    orderDiscount: 0,//discountAmount + discountPercentage
    discountTotal: "", // Line Discount + quotation Discount
    totalAmount: 0,
    subTotalAmount: 0,
  };
  
  const Validation = yup.object({
    customer: yup.object().required("Customer is required").nullable(),

  });
  const [initValue, setInitValue] = useState(initValues);
  const [currentStock, setCurrentStock] = useState(initCurrentStockValue);

  const handleStockDataChange = (e) => {
    const { name } = e.target;
    const { value } = e.target;

    setCurrentStock({
      ...currentStock,
      [name]: value,

    });
  };


  useEffect(() => {
    const getSalseOrder = async () => {
      if (code) {
        try {
          let response = await SalseOderService.get(code);
          // converting NULL value into Empty string
          response = JSON.parse(
            JSON.stringify(response).replace(/:null/gi, ':""')
          );
          setInitValue(response);
        } catch (e) {
          dispatch(openSnackbar(true, "error", e));
        }
      } else {
        setInitValue(initValues)
      }
      setIsLoaded(true);
    };
    getSalseOrder();
  }, [code, dispatch]);


  const [activeStep, setActiveStep] = React.useState(0);

  const getSteps = ["Sales Order", "Sales Order Daae"];
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  // const handleSubmit = async (values) => {
  //   setDisabledForSingle(true);
  //   try {

  //     if (code)
  //       await SalseOderService.edit({ ...values }, code);
  //     else await SalseOderService.create({
  //       ...values,
  //     });
  //     setSubmitted((prev) => !prev);
  //     setOpen(false);

  //     dispatch(
  //       openSnackbar(
  //         true,
  //         "success",
  //         `Salse order ${code ? "updated" : "created"} successfully`
  //       )
  //     );
  //   } catch (e) {
  //     dispatch(openSnackbar(true, "error", e));
  //   }

  //   setTimeout(() => {
  //     setDisabledForSingle(false);
  //   }, 10000); // 10 seconds
  // };

  const handleLineTotal = (qty, price, discountPer, discountAmount) => {
    let totalAmount = qty * price;
    discountAmount = discountAmount * qty;
    let lineTotalAmount =
      totalAmount - totalAmount * (discountPer / 100) - discountAmount;
    return lineTotalAmount;
  };
  const handleSubmit = async (values) => {
    setDisabledForSingle(true);

    try {
      const subTotalAmount = values.stockHistoryTemps.map(({ totalAmount }) => parseInt(totalAmount))
        .reduce((sum, i) => sum + i, 0);



      const totalAmount = values.stockHistoryTemps
        .map(({ quantity, discountPercentage, discountAmount, retailPrice }) =>
          handleLineTotal(
            quantity,
            retailPrice,
            discountPercentage,
            discountAmount
          )
        )
        .reduce((sum, i) => sum + i, 0);
        
      let disAmt = initValue.discountAmount;

      if (code) {
        await SalseOderService
          .edit({
            ...values,
            subTotalAmount: subTotalAmount,
            discountAmount: initValue.discountAmount,
            discountPercentage: initValue.discountPercentage,
            orderDiscount: (initValue.discountPercentage / 100 * subTotalAmount) + parseFloat(disAmt ? disAmt : 0),
            totalAmount: totalAmount,
          }, code);
      }
      else {
        await SalseOderService
          .create({
            ...values,
            subTotalAmount: subTotalAmount,
            discountAmount: initValue.discountAmount,
            discountPercentage: initValue.discountPercentage,
            orderDiscount: (initValue.discountPercentage / 100 * subTotalAmount) + parseFloat(disAmt ? disAmt : 0),
            totalAmount: totalAmount,
          });
      }
      setSubmitted((prev) => !prev);
      setOpen(false);
      dispatch(
              openSnackbar(
                true,
                "success",
                `Salse order ${code ? "updated" : "created"} successfully`
              )
            );
          } catch (e) {
            dispatch(openSnackbar(true, "error", e));
          }
      
          setTimeout(() => {
            setDisabledForSingle(false);
          }, 10000); // 10 seconds
        };
  return (
    <>
      {isLoaded ? (
        <Formik
          initialValues={initValue}
          validationSchema={Validation}
          onSubmit={async (values) => {
            if (activeStep === getSteps.length - 1) {
              await handleSubmit(values);
              console.log(values);
            } else handleNext();
          }}
        >
          {(props) => (
            <Form>
              <Stepper
                getSteps={getSteps}
                StepContent={getStepContent}
                activeStep={activeStep}
                values={props.values}
                setFieldValue={props.setFieldValue}
              />

              {/* 
            Back Button */}
              <div className="row space-between mb">
                <Button
                  disabled={activeStep === 0 || props.isValid === false}
                  onClick={handleBack}
                >
                  Back
                </Button>

                <div style={{ display: "flex" }}>
                  <Button
                    disabled={
                      disabledForSingle ||
                      props.isSubmitting ||
                        (!props.values.stockHistoryTemps.length &&
                          activeStep === getSteps.length - 1)
                        ? true
                        : false 
                        
                    }
                    startIcon={
                      props.isSubmitting && (
                        <CircularProgress color="inherit" size={20} />
                      )
                    }
                    variant="contained"
                    type="submit"
                    color="secondary"
                  >
                    {activeStep === getSteps.length - 1 ? "Complete" : "Next"}
                  </Button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      ) : (
        <Loading />
      )}
    </>
  );
  function getStepContent(step, values, setFieldValue) {

    const handleLineTotal = (qty, price, discountPer, discountAmount) => {
      let totalAmount = qty * price;
      discountAmount = discountAmount * qty;
      let lineTotalAmount = totalAmount - totalAmount * (discountPer / 100) - discountAmount;
      return lineTotalAmount;
    };
    const subTotalAmount = values.stockHistoryTemps
          .map(({ quantity, discountPercentage, discountAmount, retailPrice, warrantyPeriods }) =>
            handleLineTotal(
              quantity,
              retailPrice,
              discountPercentage,
              discountAmount,
              warrantyPeriods
            )
          )
          .reduce((sum, i) => sum + i, 0);

    const totalAmount = values.stockHistoryTemps
      .map((data) =>
        data.retailPrice * data.quantity)
      .reduce((sum, i) => sum + i, 0);
    switch (step) {
      case 0:
        return (
          <>
            <div className="row">
            <div className="col-4">
                <FormControl
                  control="asynchronousAutoComplete"
                  label="Customer"
                  name="customer"
                  Service={customerService}
                  getOptionLabel={(option) =>
                    option.firstName +
                    " " +
                    (option.secondName ?? "") +
                    " - " +
                    (option.phone1 ?? "")
                  }
                />
              </div>
              <div className="col-8">
                <FormControl name="remarks" label="Remarks" control="input" />
              </div>
            </div>
          
          </>
        );
      case 1:
        return (
          <FieldArray name="stockHistoryTemps">
            {(props) => {
              const { push, remove, form } = props;
              const { setFieldValue, values } = props.form;
              const { stockHistoryTemps } = form.values;
              return (
                <>
                  <div className="row">

                    <div className="col-9">
                      <AsyncAutoComplete
                        fullWidth
                        inputProps={{
                          placeholder: `Select Product`,
                          size: "small",
                          ref: addingProduct,
                        }}
                        variant="filled"
                        Service={ItemMasterService.posSearch}
                        value={currentStock.stock}
                        getOptionLabel={(option) =>
                          option.itemMaster.name + " - " +
                          option.itemMaster.barcode
                      
                        }
                        renderOption={(props, option) => (
                          <Box {...props}>
                            <div>
                              <div> {option.itemMaster.name} - Bc: {option.itemMaster.barcode}  <br />
                                <div>
                                  <span style={{ color: 'blue' }} >
                                    {`Qty : ${option.remainingQuantity} avl-Qty : ${option.availableQuantity}`}
                                  </span>

                                  <span className="color-red">
                                    {` CP. ${option.costPrice} | WP. ${option.wholesalePrice} | RP. ${option.retailPrice}`}
                                  </span>
                                </div>
                              </div>

                            </div>
                            <div>

                            </div>


                          </Box>
                        )}
                       
                        onChange={(e, newValue) => {
                          newValue === null
                            ? setCurrentStock({
                              ...currentStock,
                              stock: "",
                              quantity: "",

                              retailPrice:""

                            })
                            : setCurrentStock({
                              ...currentStock,
                              stock: newValue,
                              retailPrice: newValue.retailPrice,

                            })
                        }}
                      />
                    </div>
                    {/* <div className="col-3">
                        <FormControl
                          name="retailPrice"
                          label="Retail Price*"
                          control="currency"
                          onValueChange={(val) =>
                            setCurrentStock({
                              ...currentStock,
                              retailPrice: val.floatValue
                            })
                          }
                          value={currentStock.retailPrice}
                        />
                      </div> */}
                   {/* <div className="col-3">
                      <NumFormat
                        name="purchaseOrderQuantity"
                        label="PO.Quantity*"
                        control="number"
                        value={currentStock.purchaseOrderQuantity}
                        onChange={handleStockDataChange}
                        variant="outlined"
                      />
                    </div> */}
                    <div className="col-3">
                      <NumFormat
                        name="quantity"
                        label="Quantity*"
                        control="number"
                        value={currentStock.quantity}
                        onChange={handleStockDataChange}
                        variant="outlined"
                      />
                    </div>
                  </div>

                  <div className="row flex-end">
                  <Button
                        variant="contained"
                        disabled={
                          !currentStock.stock ||
                          currentStock.quantity == 0 ||
                          currentStock.purchaseOrderQuantity == 0 ||
                          currentStock.purchaseOrderQuantity < currentStock.quantity ||
                          !currentStock.retailPrice 
                         
                          
                        }

                        onClick={() => {
                        
                          if(currentStock.quantity > parseFloat( currentStock.stock.availableQuantity)) {
                            alert(`Available qunatity is ${parseFloat(currentStock.stock.availableQuantity)}`)
                            return
                          }
                          if (currentStock.editIndex || currentStock.editIndex === 0) {

                            //here when we edit , call this one
                            remove(currentStock.editIndex);
                          }
                          let lineDiscountPercentage = currentStock.discountPercentage == "" || currentStock.discountPercentage == undefined ? 0 : currentStock.discountPercentage;
                          let lineDiscountAmount = currentStock.discountAmount == "" || currentStock.discountAmount == undefined ? 0 : currentStock.discountAmount;

                          push({

                            stockCode: currentStock.stock.code,
                            itemMaster: currentStock.stock.itemMaster,
                            itemCode:currentStock.stock.itemMaster.code,
                            costPrice: currentStock.costPrice,
                            retailPrice: currentStock.retailPrice,
                            wholesalePrice: currentStock.wholesalePrice,
                            quantity: currentStock.quantity,
                            discountPercentage: lineDiscountPercentage,
                            discountAmount: lineDiscountAmount,
                            subTotalAmount: currentStock.retailPrice * currentStock.quantity,
                            totalAmount: (currentStock.retailPrice * currentStock.quantity) - ((lineDiscountAmount * currentStock.quantity) + ((currentStock.retailPrice * currentStock.quantity) * lineDiscountPercentage / 100)),
                            discountTotal: (lineDiscountAmount * currentStock.quantity) + ((currentStock.retailPrice * currentStock.quantity) * (lineDiscountPercentage / 100)),
                          });
                          setCurrentStock(initCurrentStockValue);
                        }}
                      >

                        {currentStock.editIndex || currentStock.editIndex === 0
                          ? "Update"
                          : "Add"}
                      </Button>
                  </div>
                  <div className="row mt mb">
                    <TableContainer>
                      <Table size="small" aria-label="spanning table">
                        <TableHead style={{ backgroundColor: "#cacaca50" }}>
                          <TableRow>
                            <TableCell align="center" colSpan={7}>
                              Details
                            </TableCell>
                            <TableCell align="right">Price</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell width="5"></TableCell>
                            <TableCell width="5">#</TableCell>
                            <TableCell colSpan={1}>{COLUMNS_NAME.DESCRIPTION}</TableCell>
                            <TableCell align="right">{COLUMNS_NAME.QUANTITY}</TableCell>
                            <TableCell align="right">{COLUMNS_NAME.RETAIL_PRICE}</TableCell>
                            <TableCell align="right">{COLUMNS_NAME.DISCOUNT_PERCENTAGE}</TableCell>
                            <TableCell align="right">{COLUMNS_NAME.DISCOUNT_AMOUNT}</TableCell>
                            <TableCell align="right">{COLUMNS_NAME.TOTAL}</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {values.stockHistoryTemps.map((row, i) => (
                            <TableRow key={i}>

                <TableCell>
                  <div className="flex">
                    
                      <>
                          <Delete
                        color="secondary"
                        style={{ fontSize: 18, cursor: "pointer" }}
                        onClick={() => {
                          if (
                            window.confirm("Are you sure want to delete this?")
                          )
                            remove(i);
                        }}
                      />
                      {/* <Edit
                      color="primary"
                      style={{ fontSize: 18, cursor: "pointer" }}
                      onClick={() => {
                        let dataToShow = values.stockHistoryTemps[i];
                        setCurrentStock(
                          {
                            
                            editIndex: i,
                            name: dataToShow.itemMaster ?  dataToShow.itemMaster.name : dataToShow.name,
                            quantity: dataToShow.quantity,
                            costPrice: dataToShow.costPrice,
                            wholesalePrice:  dataToShow.wholesalePrice,
                            retailPrice: dataToShow.retailPrice,
                            discountPercentage: dataToShow.discountPercentage,
                            discountAmount: dataToShow.discountAmount,
                            stock: {
                              stock: dataToShow,
                              itemMaster:dataToShow.itemMaster
                            }
                          });
                      }}
                    /> */}
                      </>
                    
                 
                   
                  </div>
                </TableCell>

                              <TableCell width="5">{i + 1}</TableCell>
                              <TableCell colSpan={1}>{row.itemMaster.name}</TableCell>
                              {/* <TableCell align="right">
                                <FormControl
                                  control="customInput"
                                  name={`stockHistoryTemps[${i}].purchaseOrderQuantity`}
                                />
                              </TableCell> */}
                              <TableCell align="right">
                                <FormControl
                                  control="customInput"
                                  name={`stockHistoryTemps[${i}].quantity`}
                                   max={currentStock.stock.availableQuantity}
                                   min={0}
                                />
                              </TableCell>
                              {/* <TableCell align="right">
                               {row.purchaseOrderQuantity - row.quantity}
                              </TableCell> */}

                               <TableCell align="right">
                                <FormControl
                                  control="customInput"
                                  name={`stockHistoryTemps[${i}].retailPrice`}
                                  min={0}
                                />
                              </TableCell>
                              <TableCell align="right">
                                <FormControl
                                  control="customInput"
                                  name={`stockHistoryTemps[${i}].discountPercentage`}
                                  min={0}
                                />
                              </TableCell>
                              <TableCell align="right">
                                <FormControl
                                  control="customInput"
                                  name={`stockHistoryTemps[${i}].discountAmount`}
                                  min={0}
                                />
                              </TableCell>
                              
                              <TableCell align="right">
                                {currency(handleLineTotal(
                                  row.quantity,
                                  row.retailPrice,
                                  row.discountPercentage,
                                  row.discountAmount
                                ))}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                        <TableHead>
                          {values.stockHistoryTemps.length === 0 ? (
                            <TableRow>
                              <TableCell align="center" colSpan={6}>
                                No Data
                              </TableCell>
                            </TableRow>
                          ) : (
                            <>
                              <TableRow>
                                <TableCell colSpan={6} />
                                <TableCell>
                                  <strong>Total</strong>
                                </TableCell>
                                <TableCell align="right">
                                  <strong>{currency(subTotalAmount)}</strong>
                                </TableCell>
                              </TableRow>
                            </>
                          )}
                        </TableHead>
                      </Table>
                    </TableContainer>
                  </div>
                </>
              );
            }}
          </FieldArray>
        );
      default:
        return null;
    }
  }
};

export default SalesOrder;